export default __webpack_public_path__ + "static/media/choosing-second-card.f0d8fc58.svg";